import dayjs, { Dayjs } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

const serverFormatPattern = 'YYYY-MM-DDTHH:mm:ss.000ZZ'

export const formatServerTimeToDayjs = (date: string): Dayjs => dayjs(date, serverFormatPattern)

export const formatDayjsToServerTime = (date: Dayjs): string => date.format(serverFormatPattern)
